import styled from 'styled-components';

export const HorizontalDivider = styled.div<{
  $width: string;
  $color?: string;
}>`
  border-top: 1px solid
    ${(props) =>
      props.$color ?? props.theme.atlas.semantic.color.ui.divider.default};
  width: ${(props) => props.$width};
  height: 0;
`;

export const VerticalDivider = styled.div<{ $height: string; $color?: string }>`
  border-left: 1px solid
    ${(props) =>
      props.$color ?? props.theme.atlas.semantic.color.ui.divider.default};
  height: ${(props) => props.$height};
  width: 0;
`;
